export const DEFAULT_FLOATING_GROUP_OVERFLOW_SIZE = 100;
export const DEFAULT_FLOATING_GROUP_POSITION = {
    left: 100,
    top: 100,
    width: 300,
    height: 300,
};
export const DESERIALIZATION_POPOUT_DELAY_MS = 100;
